class PDPColourVariants extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const colourSwiper = new Swiper(this.querySelector('.product-variant-swatches'), {
      slidesPerView: 4,
      spaceBetween: 17,
      navigation: {
        nextEl: this.querySelector('[data-carousel-next]'),
        prevEl: this.querySelector('[data-carousel-prev]')
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1500: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
    });
  }
}

customElements.define("pdp-colour-variants", PDPColourVariants);
